import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    max-width: 600px !important;
  }
`;

export const ModalTitle = styled.h2`
  color: ${({ theme }) => theme.colors.black10};
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const Wrapper = styled.div`
  text-align: center;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 1rem;

  button {
    margin-left: 0.5rem;
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const Name = styled.h2`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const DescriptionWrapper = styled.div`
  text-align: left;
  margin: 1rem 0;
`;

export const Title = styled.h4`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const Description = styled.p<{ $expanded: boolean; $isEmpty: boolean }>`
  color: ${({ theme, $isEmpty }) => ($isEmpty ? theme.colors.black6 : theme.colors.black9)};
  margin: 0;
  max-height: ${({ $expanded }) => ($expanded ? 'none' : '4.5em')};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ $expanded }) => ($expanded ? 'unset' : 3)};
  -webkit-box-orient: vertical;

  span {
    display: inline-block;
    color: ${({ theme }) => theme.colors.black9};
    cursor: pointer;
    margin-top: 0.25rem;
  }
`;

export const ShowMoreButton = styled.button`
  color: ${({ theme }) => theme.colors.black9};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const Content = styled.div`
  text-align: left;
`;

export const Field = styled.div`
  margin-bottom: 1rem;
`;

export const FooterStats = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  padding: 0 0 10px 0;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    gap: 1rem;
  }
`;

export const StatCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 24px;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
  }
`;

export const WrapperStats = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-left: 10px;
  }
`;

export const BoldText = styled.span`
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
`;
